<template>
  <svg style="position: absolute; width: 0; height: 0;">
    <defs>
      <pattern v-for="id in 5" :id="'c' + (18 + id + '.' + uniq_key)" :key="18+id" width="1" height="1"
               patternContentUnits="objectBoundingBox">
        <image :xlink:href="require('../assets/img/c' + (18 + id) + '.gif')" width="1" height="1"/>
      </pattern>
      <pattern v-for="id in 6" :id="'c' + (28 + id + '.' + uniq_key)" :key="28+id" width="1" height="1"
               patternContentUnits="objectBoundingBox">
        <image :xlink:href="require('../assets/img/c' + (28 + id) + '.gif')" width="1" height="1"/>
      </pattern>
      <pattern v-for="id in 7" :id="'c' + (36 + id + '.' + uniq_key)" :key="36+id" width="1" height="1"
               patternContentUnits="objectBoundingBox">
        <image :xlink:href="require('../assets/img/c' + (36 + id) + '.gif')" width="1" height="1"/>
      </pattern>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'ColorPattern',
    props: {
      'uniq_key': String,
    }
  };
</script>

<style scoped lang="scss">
</style>
